import { TranslationModel } from '../translation/translation-model';
import { RotationModel } from '../rotation/rotation-model';
import { RotationDirectionType } from '../rotation/rotation-direction-type';
var DynamicDisplayModel = /** @class */ (function () {
    function DynamicDisplayModel(isTranslation, isHorizontalTranslation, isVerticalTranslation, isRotation, horizontalTranslation, verticalTranslation, rotation) {
        if (isTranslation === void 0) { isTranslation = false; }
        if (isHorizontalTranslation === void 0) { isHorizontalTranslation = false; }
        if (isVerticalTranslation === void 0) { isVerticalTranslation = false; }
        if (isRotation === void 0) { isRotation = false; }
        this.isTranslation = isTranslation;
        this.isHorizontalTranslation = isHorizontalTranslation;
        this.isVerticalTranslation = isVerticalTranslation;
        this.isRotation = isRotation;
        this.horizontalTranslation = horizontalTranslation;
        this.verticalTranslation = verticalTranslation;
        this.rotation = rotation;
    }
    DynamicDisplayModel.default = function () {
        var model = new DynamicDisplayModel();
        model.rotation = new RotationModel(RotationDirectionType.ClockWise, '', 0, 360, false, 0, 360, false, '', 0, undefined);
        model.horizontalTranslation =
            new TranslationModel('', 0, 0, false, 0, 0, false, '', 0, undefined);
        model.verticalTranslation =
            new TranslationModel('', 0, 0, false, 0, 0, false, '', 0, undefined);
        return model;
    };
    DynamicDisplayModel.addDefaultForRotationTranslation = function (model) {
        if (!model.rotation) {
            model.rotation = new RotationModel(RotationDirectionType.ClockWise, '', 0, 360, false, 0, 360, false, '', 0, undefined);
        }
        if (!model.horizontalTranslation) {
            model.horizontalTranslation =
                new TranslationModel('', 0, 0, false, 0, 0, false, '', 0, undefined);
        }
        if (!model.verticalTranslation) {
            model.verticalTranslation =
                new TranslationModel('', 0, 0, false, 0, 0, false, '', 0, undefined);
        }
    };
    return DynamicDisplayModel;
}());
export { DynamicDisplayModel };
